import { Migration_200521_intendedListToTree } from './200521_intendedListToTree'
import { createMigrate as createReduxMigrate } from 'redux-persist'

export default {
    1: (state) => new Migration_200521_intendedListToTree().up(state)
}

export function createMigrate(migrations, config) {
    return (state, currentVersion) => {
        const reduxMigrate = createReduxMigrate(migrations, config)

        // If no state from IndexedDb check if localstorage has anything to offer
        if (!state) {
            try {
                console.log('redux-persist/legacy: no inbound state, running legacy state migration')

                // This could be simplified by using https://github.com/rt2zz/redux-persist/blob/master/docs/api.md#getstoredstateconfig
                // but we cannot since it returns promise and migrations cannot yet handle async functions:
                // https://github.com/rt2zz/redux-persist/pull/1219
                state = JSON.parse(localStorage.getItem('persist:treelist-data'))
                Object.keys(state).forEach((key) => {
                    state[key] = JSON.parse(state[key])
                })
                localStorage.removeItem('persist:treelist-data')
            } catch (error) {
                console.error('redux-persist/legacy: migration error', error)
            }
        }

        // Trigger versioned migrations
        return reduxMigrate(state, currentVersion)
    }
}
